import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterButton } from 'components/WrappedComponents';
import { FilterDashboardFourriere } from 'types/referentiels/Fourriere';

import FilterFormFourriere from './FilterFormFourriere';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardFourriere>) => void;
  filter: Partial<FilterDashboardFourriere>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { enabled, ...formFilter } = filter;
  function setFormFilter(value: Partial<FilterDashboardFourriere>) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  function setDisplayInvalidUniteFo(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      enabled: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <FilterFormFourriere filter={data} setFilter={setData} />
        )}
      </FilterButton>
      <AntdCheckbox
        checked={!enabled}
        onChange={setDisplayInvalidUniteFo}
        className="checkbox-unites-inactives"
      >
        Afficher les fourrières inactives
      </AntdCheckbox>
    </div>
  );
}
